import ToC from './ToC';

export default ToC;
